module.exports = __webpack_public_path__ + "static/media/john-deanfield-r.6ffff38a.jpg";